import styled from 'styled-components';

const PromotionsButton = styled.a`
  &.promotions-button {
    display: block;
    cursor: pointer;
    background-color: #c88821;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
    font-size: 1.4em;
    max-height: 3em;
    padding-left: 1.5em;
    padding-right: 1.5em;
    margin-top: 1em;
    margin-bottom: 0.5em;
    color: #fff;
    text-decoration: none;
    text-align: center;

    &:hover {
      background-color: #b19058;
    }

    @media screen and (min-width: ${props => props.theme.breakpoints.small}) {
      margin: 0 0 0 2em;
    }
  }
`;

export default PromotionsButton;
